export const stringSlice = (str, endIndex) => {
  return `${str.slice(0, endIndex)}...`;
};

export const initJqueyrPlugins = () => {
  var windowObject = window;

  if (windowObject.$(".main-header li.dropdown ul").length) {
    windowObject
      .$(".main-header li.dropdown")
      .append(
        '<div class="dropdown-btn"><span class="fa fa-angle-down"></span></div>'
      );

    //Dropdown Button
    windowObject
      .$(".main-header li.dropdown .dropdown-btn")
      .on("click", function() {
        windowObject
          .$(this)
          .prev("ul")
          .slideToggle(500);
      });

    //Disable dropdown parent link
    windowObject
      .$(".main-header .navigation li.dropdown > a")
      .on("click", function(e) {
        e.preventDefault();
      });
  }

  if (windowObject.$(".testimonial-carousel-one").length) {
    windowObject.$(".testimonial-carousel-one").owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      smartSpeed: 700,
      autoplay: 5000,
      navText: [
        '<span class="flaticon-arrows-2"></span>',
        '<span class="flaticon-arrows"></span>'
      ],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1024: {
          items: 1
        }
      }
    });
  }

  if (windowObject.$(".count-box").length) {
    windowObject.$(".count-box").appear(
      function() {
        var $t = windowObject.$(this),
          n = $t.find(".count-text").attr("data-stop"),
          r = parseInt($t.find(".count-text").attr("data-speed"), 10);

        if (!$t.hasClass("counted")) {
          $t.addClass("counted");
          windowObject
            .$({
              countNum: $t.find(".count-text").text()
            })
            .animate(
              {
                countNum: n
              },
              {
                duration: r,
                easing: "linear",
                step: function() {
                  $t.find(".count-text").text(Math.floor(this.countNum));
                },
                complete: function() {
                  $t.find(".count-text").text(this.countNum);
                }
              }
            );
        }
      },
      { accY: 0 }
    );
  }

  if (windowObject.$(".pricing-tabs").length) {
    windowObject.$(".pricing-tabs .tab-btns .tab-btn").on("click", function(e) {
      e.preventDefault();
      var target = windowObject.$(windowObject.$(this).attr("data-tab"));

      if (windowObject.$(target).hasClass("actve-tab")) {
        return false;
      } else {
        windowObject
          .$(".pricing-tabs .tab-btns .tab-btn")
          .removeClass("active-btn");
        windowObject.$(this).addClass("active-btn");
        windowObject
          .$(".pricing-tabs .pr-content .pr-tab")
          .removeClass("active-tab");
        windowObject.$(target).addClass("active-tab");
      }
    });
  }

  if (windowObject.$(".accordion-box").length) {
    windowObject.$(".accordion-box").on("click", ".acc-btn", function() {
      var target = windowObject.$(this).parents(".accordion");

      if (windowObject.$(this).hasClass("active") !== true) {
        windowObject.$(".accordion .acc-btn").removeClass("active");
      }

      if (
        windowObject
          .$(this)
          .next(".acc-content")
          .is(":visible")
      ) {
        //$(this).removeClass('active');
        return false;
        //$(this).next('.accord-content').slideUp(300);
      } else {
        windowObject.$(this).addClass("active");
        windowObject.$(".accordion").removeClass("active-block");
        windowObject.$(".accordion .acc-content").slideUp(300);
        target.addClass("active-block");
        windowObject
          .$(this)
          .next(".acc-content")
          .slideDown(300);
      }
    });
  }

  if (windowObject.$(".sponsors-carousel").length) {
    windowObject.$(".sponsors-carousel").owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      smartSpeed: 500,
      autoplay: 5000,
      navText: [
        '<span class="fa fa-angle-left"></span>',
        '<span class="fa fa-angle-right"></span>'
      ],
      responsive: {
        0: {
          items: 2
        },
        600: {
          items: 3
        },
        800: {
          items: 3
        },
        1024: {
          items: 4
        },
        1200: {
          items: 5
        }
      }
    });
  }

  if (windowObject.$(".single-item-carousel").length) {
    windowObject.$(".single-item-carousel").owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      smartSpeed: 700,
      autoplay: 4000,
      navText: [
        '<span class="fa fa-angle-left"></span>',
        '<span class="fa fa-angle-right"></span>'
      ],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        800: {
          items: 1
        },
        1024: {
          items: 1
        },
        1200: {
          items: 1
        }
      }
    });
  }

  if (windowObject.$(".lightbox-image").length) {
    windowObject.$(".lightbox-image").fancybox({
      openEffect: "fade",
      closeEffect: "fade",
      helpers: {
        media: {}
      }
    });
  }

  if (windowObject.$(".wow").length) {
    var wow = new windowObject.WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: false, // trigger animations on mobile devices (default is true)
      live: true // act on asynchronously loaded content (default is true)
    });
    wow.init();
  }

  if (windowObject.$(".filter-list").length) {
    windowObject.$(".filter-list").mixItUp({});
  }

  // Scroll to a Specific Div
  if (windowObject.$(".scroll-to-top").length) {
    windowObject.$(".scroll-to-top").on("click", function() {
      windowObject.$("html, body").animate({ scrollTop: 0 }, 1000);
    });
  }

  /* ==========================================================================
	   When document is Scrollig, do
	   ========================================================================== */

  windowObject.$(window).on("scroll", function() {
    if (windowObject.$(".main-header").length) {
      var windowpos = windowObject.$(window).scrollTop();
      var siteHeader = windowObject.$(".main-header");
      var scrollLink = windowObject.$(".scroll-to-top");
      if (windowpos >= 200) {
        siteHeader.addClass("fixed-header");
        scrollLink.fadeIn(300);
      } else {
        siteHeader.removeClass("fixed-header");
        scrollLink.fadeOut(300);
      }
    }
  });

  /* ==========================================================================
	   When document is loading, do
	   ========================================================================== */

  windowObject.$(window).on("load", function() {
    if (windowObject.$(".preloader").length) {
      windowObject
        .$(".preloader")
        .delay(200)
        .fadeOut(500);
    }
  });
};

export const mapQuestInit = () => {
  var windowObject = window;

  windowObject.L.mapquest.key = "L1nMMJD9K04VeC4K9jwRGyM4RVZm1esb";

  var map = windowObject.L.mapquest.map("map", {
    center: [40.189671, 29.070259],
    layers: windowObject.L.mapquest.tileLayer("map"),
    zoom: 15
  });

  windowObject.L.marker([40.189671, 29.070259], {
    icon: windowObject.L.mapquest.icons.marker(),
    draggable: false
  }).addTo(map);
  map.addControl(windowObject.L.mapquest.control());

  // var Gmap = window.$('.map-canvas');
  // Gmap.each(function () {
  // 	var $this = window.$(this),
  // 		lat = '',
  // 		lng = '',
  // 		zoom = 12,
  // 		scrollwheel = false,
  // 		zoomcontrol = true,
  // 		draggable = true,
  // 		mapType = window.google.maps.MapTypeId.ROADMAP,
  // 		title = '',
  // 		contentString = '',
  // 		theme_icon_path = $this.data('icon-path'),
  // 		dataLat = $this.data('lat'),
  // 		dataLng = $this.data('lng'),
  // 		dataZoom = $this.data('zoom'),
  // 		dataType = $this.data('type'),
  // 		dataScrollwheel = $this.data('scrollwheel'),
  // 		dataZoomcontrol = $this.data('zoomcontrol'),
  // 		dataHue = $this.data('hue'),
  // 		dataTitle = $this.data('title'),
  // 		dataContent = $this.data('content');

  // 	if (dataZoom !== undefined && dataZoom !== false) {
  // 		zoom = parseFloat(dataZoom);
  // 	}
  // 	if (dataLat !== undefined && dataLat !== false) {
  // 		lat = parseFloat(dataLat);
  // 	}
  // 	if (dataLng !== undefined && dataLng !== false) {
  // 		lng = parseFloat(dataLng);
  // 	}
  // 	if (dataScrollwheel !== undefined && dataScrollwheel !== null) {
  // 		scrollwheel = dataScrollwheel;
  // 	}
  // 	if (dataZoomcontrol !== undefined && dataZoomcontrol !== null) {
  // 		zoomcontrol = dataZoomcontrol;
  // 	}
  // 	if (dataType !== undefined && dataType !== false) {
  // 		if (dataType === 'satellite') {
  // 			mapType = window.google.maps.MapTypeId.SATELLITE;
  // 		} else if (dataType === 'hybrid') {
  // 			mapType = window.google.maps.MapTypeId.HYBRID;
  // 		} else if (dataType === 'terrain') {
  // 			mapType = window.google.maps.MapTypeId.TERRAIN;
  // 		}
  // 	}
  // 	if (dataTitle !== undefined && dataTitle !== false) {
  // 		title = dataTitle;
  // 	}
  // 	if (navigator.userAgent.match(/iPad|iPhone|Android/i)) {
  // 		draggable = false;
  // 	}

  // 	var mapOptions = {
  // 		zoom: zoom,
  // 		scrollwheel: scrollwheel,
  // 		zoomControl: zoomcontrol,
  // 		draggable: draggable,
  // 		center: new window.google.maps.LatLng(lat, lng),
  // 		mapTypeId: mapType
  // 	};
  // 	var map = new window.google.maps.Map($this[0], mapOptions);

  // 	//var image = 'images/icons/map-marker.png';
  // 	var image = theme_icon_path;

  // 	if (dataContent !== undefined && dataContent !== false) {
  // 		contentString = `<div class="map-data"><h6>${title}</h6> <div class="map-content">${dataContent}</div></div>`;
  // 	}
  // 	var infowindow = new window.google.maps.InfoWindow({
  // 		content: contentString
  // 	});

  // 	var marker = new window.google.maps.Marker({
  // 		position: new window.google.maps.LatLng(lat, lng),
  // 		map: map,
  // 		icon: image,
  // 		title: title
  // 	});
  // 	if (dataContent !== undefined && dataContent !== false) {
  // 		window.google.maps.event.addListener(marker, 'click', function () {
  // 			infowindow.open(map, marker);
  // 		});
  // 	}

  // 	if (dataHue !== undefined && dataHue !== false) {
  // 		var styles = [
  // 			{
  // 				"featureType": "administrative",
  // 				"elementType": "labels.text.fill",
  // 				"stylers": [
  // 					{
  // 						"color": "#444444"
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "landscape",
  // 				"elementType": "all",
  // 				"stylers": [
  // 					{
  // 						"color": "#dfdfdf"
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "poi",
  // 				"elementType": "all",
  // 				"stylers": [
  // 					{
  // 						"visibility": "on"
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "road",
  // 				"elementType": "all",
  // 				"stylers": [
  // 					{
  // 						"saturation": -100
  // 					},
  // 					{
  // 						"lightness": 50
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "road.highway",
  // 				"elementType": "all",
  // 				"stylers": [
  // 					{
  // 						"visibility": "simplified"
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "road.arterial",
  // 				"elementType": "labels.icon",
  // 				"stylers": [
  // 					{
  // 						"visibility": "off"
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "transit",
  // 				"elementType": "all",
  // 				"stylers": [
  // 					{
  // 						"visibility": "off"
  // 					}
  // 				]
  // 			},
  // 			{
  // 				"featureType": "water",
  // 				"elementType": "all",
  // 				"stylers": [
  // 					{
  // 						"color": "#99ceff"
  // 					},
  // 					{
  // 						"visibility": "on"
  // 					}
  // 				]
  // 			}
  // 		];
  // 		map.setOptions({ styles: styles });
  // 	}
  // });
};



// WEBPACK FOOTER //
// ./src/config/utility.js